// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MenuV5 = require("../Components/menu/MenuV5.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ContactAgentButton_agent_graphql = require("../../../__generated__/ContactAgentButton_agent_graphql.bs.js");

let convertFragment = ContactAgentButton_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ContactAgentButton_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ContactAgentButton_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ContactAgentButton_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ContactAgentButton_agent_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ContactAgentButton(props) {
  let __children = props.children;
  let __variant = props.variant;
  let __fullWidth = props.fullWidth;
  let __position = props.position;
  let onInitiateConversation = props.onInitiateConversation;
  let position = __position !== undefined ? __position : "bottom";
  let fullWidth = __fullWidth !== undefined ? __fullWidth : false;
  let variant = __variant !== undefined ? __variant : "Primary";
  let children = __children !== undefined ? __children : "Contact agent";
  let match = RescriptRelay_Fragment.useFragment(ContactAgentButton_agent_graphql.node, convertFragment, props.agent);
  let phone = match.phone;
  let emailAddress = match.emailAddress;
  let displayName = match.displayName;
  let disabled = onInitiateConversation === undefined;
  let button;
  switch (variant) {
    case "Primary" :
      button = JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
        disabled: disabled,
        size: "small",
        className: TailwindMerge.twMerge([fullWidth ? "w-full justify-center" : ""]),
        children: children
      });
      break;
    case "Secondary" :
      button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        disabled: disabled,
        size: "small",
        className: TailwindMerge.twMerge([fullWidth ? "w-full justify-center" : ""]),
        children: children
      });
      break;
    case "Link" :
      button = JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
        disabled: disabled,
        size: "small",
        className: TailwindMerge.twMerge([fullWidth ? "w-full justify-center" : ""]),
        children: children
      });
      break;
  }
  let tmp;
  tmp = onInitiateConversation !== undefined ? (
      onInitiateConversation.TAG === "Navigate" ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
          href: onInitiateConversation._0,
          children: "Message on TAN"
        }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: onInitiateConversation._0,
          children: "Message on TAN"
        })
    ) : null;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(MenuV5.Menu.make, {
      button: button,
      children: [
        tmp,
        phone !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(MenuV5.MenuItem.make, {
                href: `tel:` + phone,
                children: "Call"
              }),
              JsxRuntime.jsx(MenuV5.MenuItem.make, {
                href: `sms:` + phone,
                children: "Send a text"
              })
            ]
          }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: prim => {},
            isDisabled: true,
            children: `No phone number for ` + displayName
          }),
        emailAddress !== undefined ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
            href: `mailto:` + Scalars.EmailAddress.toString(Primitive_option.valFromOption(emailAddress)),
            children: "Email"
          }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: prim => {},
            isDisabled: true,
            children: `No email address for ` + displayName
          })
      ],
      placement: position === "top" ? "top start" : "bottom start"
    }),
    className: "relative"
  });
}

let make = ContactAgentButton;

exports.Fragment = Fragment;
exports.make = make;
/* MenuV5 Not a pure module */
